/**
 * The puzzle paste: one puzzle per line, `question = answer`, hints after `|`
 * (`Столица России? = Москва | Rossiyada | M harfi bilan`). The answer is split off at the
 * LAST `=` of the question part, so a question may itself contain one (`2 + 2 = ? = 4`).
 */

/** Limits of the API's CreateGamePuzzleDto / UpdateGamePuzzleDto; at most 100 per request. */
export const PUZZLE_LIMITS = { prompt: 2000, answer: 1000, hint: 1000 };
export const MAX_BULK_PUZZLES = 100;

const LIST_NUMBER = /^\s*\d{1,3}[.)]\s+/;

/**
 * @param {string} text
 * @returns {{ puzzles: Array<{ line: number, prompt: string, answer: string, hints: string[] }>,
 *            errors: Array<{ line: number, text: string, reason: 'missingEquals'|'missingQuestion'|'missingAnswer'|'tooLong' }> }}
 */
export function parsePuzzleList(text) {
  const puzzles = [];
  const errors = [];

  String(text || '').split(/\r?\n/).forEach((raw, index) => {
    const line = index + 1;
    const content = raw.replace(LIST_NUMBER, '').trim();
    if (!content) return;
    const fail = (reason) => errors.push({ line, text: raw.trim(), reason });

    const [qa, ...hintParts] = content.split('|');
    const eq = qa.lastIndexOf('=');
    if (eq === -1) return fail('missingEquals');
    const prompt = qa.slice(0, eq).trim();
    const answer = qa.slice(eq + 1).trim();
    if (!prompt) return fail('missingQuestion');
    if (!answer) return fail('missingAnswer');
    const hints = hintParts.map((h) => h.trim()).filter(Boolean);
    if (
      prompt.length > PUZZLE_LIMITS.prompt
      || answer.length > PUZZLE_LIMITS.answer
      || hints.some((h) => h.length > PUZZLE_LIMITS.hint)
    ) {
      return fail('tooLong');
    }
    puzzles.push({ line, prompt, answer, hints });
  });

  return { puzzles, errors };
}
